<div class="mt-3 animated fadeIn">
  <h4>Licensures</h4>
  <ng-container *ngIf="licensures | async | sortBy: 'desc':'yearConferred' as items; else loading">
    <div class="table-responsive">
      <table class="table table-striped border mt-3 shadow-sm" [class.table-sm]="isMobile | async">
        <thead>
          <tr>
            <th *ngFor="let head of licensuresHeadElements" scope="col">{{head}} </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let el of items">
            <td>{{ el.typeOfLicensure }}</td>
            <td>{{ el.stateOrProvince }}</td>
            <td>{{ el.yearConferred }}</td>
            <td>{{ el.status }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</div>

<ng-template #loading>
  <ngx-skeleton-loader count="10"></ngx-skeleton-loader>
</ng-template>